import {
  ObjectEx
} from "vue-objectex";
import {
  runObjectExtender
} from "vue-js-extender";
runObjectExtender();

const MomentDateFormatISO = "YYYY-MM-DD";
const MomentDateFormatUSA = "MM/DD/YYYY";
const MomentDateFormatCHN = "YYYY/MM/DD";

const debug = function (arg1, arg2, arg3) {
  console.log("debug:", arg1, arg2, arg3);
  return arg1;
};

const enumGlobalSettingType = new ObjectEx([{
    key: "DBVersion",
    value: 1,
    desc: "数据库版本"
  },
  {
    key: "EnableAutonomousEnrolment",
    value: 2,
    desc: "自主报课"
  },
  {
    key: "IsTaxIncluded",
    value: 3,
    desc: "是否含税"
  },
  {
    key: "HasOrganizationChart",
    value: 4,
    desc: "组织结构图"
  }
]);

const roleType = new ObjectEx([{
    key: "admin",
    value: 1,
    name: "1",
    label: "管理员",
    type: "管理员"
  },
  {
    key: "student",
    value: 2,
    name: "2",
    label: "学生",
    type: "学生"
  },
  {
    key: "teacher",
    value: 3,
    name: "3",
    label: "老师",
    type: "老师"
  },
  {
    key: "sales",
    value: 4,
    name: "4",
    label: "行政销售",
    type: "前台"
  },
  {
    key: "assistant",
    value: 5,
    name: "5",
    label: "行政助理",
    type: "前台"
  },
  {
    key: "financialManager",
    value: 6,
    name: "6",
    label: "财务主管",
    type: "财务"
  },
  {
    key: "executiveManager",
    value: 7,
    name: "7",
    label: "行政管理",
    type: "前台"
  },
  {
    key: "educationalAssistant",
    value: 8,
    name: "8",
    label: "教务助理",
    type: "前台"
  },
  {
    key: "financialAssistant",
    value: 9,
    name: "9",
    label: "财务助理",
    type: "财务"
  },
  {
    key: "platformEditor",
    value: 10,
    name: "10",
    label: "平台编辑",
    type: "前台"
  },
  {
    key: "receptionist",
    value: 11,
    name: "11",
    label: "前台客服",
    type: "前台"
  },
  {
    key: "academicDirector",
    value: 12,
    name: "12",
    label: "教务总监",
    type: "前台"
  },
  {
    key: "personnelManagement",
    value: 13,
    name: "13",
    label: "人事管理",
    type: "前台"
  },
  {
    key: "regionCEO",
    value: 14,
    name: "14",
    label: "地区CEO",
    type: "前台"
  },
  {
    key: "campusPresident",
    value: 15,
    name: "15",
    label: "校区校长",
    type: "前台"
  },
  {
    key: "financialAccounting",
    value: 16,
    name: "16",
    label: "财务会计",
    type: "财务"
  },
  {
    key: "saBusinessManager",
    value: 17,
    name: "17",
    label: "真留业务主管",
    type: "真留",
    type2: "业务"
  },
  {
    key: "saBusinessSales",
    value: 18,
    name: "18",
    label: "真留业务销售",
    type: "真留",
    type2: "业务"
  },
  {
    key: "saBusinessAssistant",
    value: 19,
    name: "19",
    label: "真留业务助理",
    type: "真留",
    type2: "业务"
  },
  {
    key: "saFinancialManager",
    value: 20,
    name: "20",
    label: "真留财务主管",
    type: "真留",
    type2: "财务"
  },
  {
    key: "saFinancialAssistant",
    value: 21,
    name: "21",
    label: "真留财务助理",
    type: "真留",
    type2: "财务"
  },
  {
    key: "parent",
    value: 22,
    name: "22",
    label: "家长",
    type: "家长",
  },
  {
    key: "vocationalTrainingManager",
    value: 23,
    name: "23",
    label: "职业培训主管",
    type: "前台",
  },
  {
    key: "internationalSales",
    value: 24,
    name: "24",
    label: "国际销售",
    type: "前台",
  },
], {
  getOptionsByType(type, type2 = null, exceptKeys = null) {
    let enumOptions = this.getOptions(enumOption => enumOption.type === type);

    if (!!type2) {
      enumOptions = enumOptions.filter(enumOption => enumOption.type2 === type2);
    }

    if (Object.typeOf(exceptKeys) === "array") {
      enumOptions = enumOptions.filter(enumOption => !exceptKeys.contains(enumOption.key));
    }

    return enumOptions;
  },
  getOptionsByKeys(keys) {
    if (Object.typeOf(keys) !== "array")
      return [];

    return this.getOptions(enumOption => keys.contains(enumOption.key));
  }
});

const loginType = {
  student: {
    name: "学生"
  },
  speedup: {
    name: "速成人员"
  },
};

const bonusPointMechanismType = {
  moneyToBonusPoint: 1,
  bonusPointToMoney: 2,
};

const globalPriceType = {
  universityTutoringPrice: 1,
  normalVideoPrice: 2,
  supplementVideoPrice: 3,
  membershipCardPrice: 4,
  paymentCommissionRate: 5,
  advanceEnrollmentPrice: 6,
  renewMembershipCardPrice: 7,
  academicPlanningOnce: 8,
  academicPlanningUnlimited: 9,
  trainingAdvanceEnrollmentPrice: 10,
  renewMembershipCardPriceDiscount: 11,
  afterDiscountMembershipCardPrice: 12,
  videoAppointmentDepositPrice: 13,
  extendMembershipCardPrice: 14,
  airportPickUpPrice: 15,
  videoPackagePrice: 16,
  trainingVideoWatchingDuration: 17,
  autoEnrollCoursePrice: 18
};

const formulaType = {
  none: 0,
  discount: 1,
  systemVariable: 2,
  customVariable: 3,
};

const accountType = {
  none: 0,
  advanceEnrollment: 1,
  signClass: 2,
  memberCard: 3,
  renewMemberCard: 4,
  watchVideos: 5,
  bonusPointExchangeItem: 6,
  academicPlanning: 7,
  trainingAdvanceEnrollment: 8,
  trainingSignClass: 9,
  englishSignClass: 10,
  topUpBalance: 11,
  videoAppointment: 12,
  videoAppointmentDeposit: 13,
  extendMemberCard: 14,
  editStudentBalanceAndBonusPoint: 15,
  resetAdvanceEnrollment: 16,
  studyAbroad: 17,
  newStudentGuideSignClass: 18,
  airportPickUp: 19,
  videoPackage: 20,
  autoEnrollCourse: 21
};

const contractType = new ObjectEx([{
    key: "none",
    value: 0
  },
  {
    key: "advanceEnrollment",
    value: 1,
    desc: "占位"
  },
  {
    key: "universityCourse",
    value: 2,
    desc: "大学课程",
    courseType: 1
  },
  {
    key: "englishCourse",
    value: 3,
    desc: "应试英语",
    courseType: 2
  },
  {
    key: "vocationalTraining",
    value: 4,
    desc: "职业培训",
    courseType: 3
  },
  {
    key: "studyAbroadSpeedup",
    value: 5,
    desc: "真留速成收款"
  },
  {
    key: "studyAbroadChannel",
    value: 6,
    desc: "真留渠道收款"
  },
  {
    key: "newStudentGuide",
    value: 7,
    desc: "新生引流",
    courseType: 4
  },
  {
    key: "courseReplayRule",
    value: 8,
    desc: "上课形式与回放规则须知",
  }
], {
  getDesc(value) {
    let enumOption = this.valueOf(value);
    return !!enumOption ? enumOption.desc : null;
  },
  getValueByCourseType(courseType) {
    let enumOptions = this.getOptions((op) => op.courseType === courseType);
    let values = enumOptions.map((op) => op.value);

    return values.length > 0 ? values[0] : 0;
  }
});

const otherCollectFeeType = {
  memberCard: {
    value: 1,
    description: "会员卡"
  },
  renewMemberCard: {
    value: 2,
    description: "补办会员卡"
  },
  watchVideos: {
    value: 3,
    description: "看视频"
  },
  bonusPointExchangeItem: {
    value: 4,
    description: "积分兑换物品"
  },
  academicPlanning: {
    value: 5,
    description: "学业规划"
  },
  topUpBalance: {
    value: 6,
    description: "充值余额"
  },
  extendMemberCard: {
    value: 7,
    description: "续办会员卡"
  },
  airportPickUp: {
    value: 8,
    description: "接机服务"
  },
  videoPackage: {
    value: 9,
    description: "视频包"
  },
  autoEnrollCourse: {
    value: 10,
    description: "刷课"
  }
};

const courseType = new ObjectEx([{
    key: "none",
    value: 0,
    desc: String.empty
  },
  {
    key: "university",
    value: 1,
    desc: "大学补习"
  },
  {
    key: "english",
    value: 2,
    desc: "应试英语"
  },
  {
    key: "vocationalTraining",
    value: 3,
    desc: "职业培训"
  },
  {
    key: "newStudentGuide",
    value: 4,
    desc: "新生引流"
  },
]);

const enumYearCourseType = new ObjectEx([{
    key: "None",
    value: 0
  },
  {
    key: "All",
    value: 1,
    desc: "全年课"
  },
  {
    key: "Last",
    value: 2,
    desc: "上学期"
  },
  {
    key: "Next",
    value: 3,
    desc: "下学期"
  }
], {
  getDesc(value) {
    let enumOption = this.valueOf(value);
    return !!enumOption ? enumOption.desc : null;
  }
});

const universityGroup = {
  SFU: {
    value: 1,
    description: ""
  },
  UBC: {
    value: 2,
    description: ""
  },
  None: {
    value: 3,
    description: ""
  },
  UTM: {
    value: 5,
    description: ""
  },
  CC: {
    value: 7,
    description: ""
  },
  UTSG: {
    value: 8,
    description: ""
  },
};

const campuseType = {
  SFU: 1,
  UBC: 3,
  UTM: 4,
  UTSG: 6,
  Metro: 7,
};

const enumPaymentType = new ObjectEx([{
    key: "cash",
    value: 1,
    desc: "现金"
  },
  {
    key: "wechat",
    value: 2,
    desc: "微信"
  },
  {
    key: "alipay",
    value: 3,
    desc: "支付宝"
  },
  {
    key: "debit",
    value: 4,
    desc: "Debit"
  },
  {
    key: "paypal",
    value: 5,
    desc: "PayPal"
  },
  {
    key: "union",
    value: 6,
    desc: "银联"
  },
  {
    key: "visa",
    value: 7,
    desc: "VISA"
  },
  {
    key: "master",
    value: 8,
    desc: "MasterCard"
  },
  {
    key: "emt",
    value: 9,
    desc: "EMT"
  },
  {
    key: "cheque",
    value: 10,
    desc: "支票"
  },
  {
    key: "creditCard",
    value: 11,
    desc: "信用卡"
  },
], {
  getDesc(value) {
    let enumOption = this.valueOf(value);
    return !!enumOption ? enumOption.desc : null;
  },
  getOptionsForCheckpay(excepts, withOther) {
    let typeList = [this.wechat, this.alipay, this.creditCard, this.emt];
    let retValue = this.getOptions().filter(item => typeList.contains(item.value));

    if (Object.typeOf(excepts) === "array")
      retValue = retValue.filter(item => !excepts.contains(item.value));
    else if (Object.typeOf(excepts) === "number")
      retValue = retValue.filter(item => item.value !== excepts);

    if (withOther)
      retValue.insert(0, {
        key: "other",
        value: null,
        desc: "任意"
      });

    return retValue;
  }
});

const bypassVideoAppointment = false;
const isOnlineCourse = true;
const wechatEnable = true;
const haoJiangTaiDisabled = true;

const courseScheduleSetting = {
  start: 8,
  end: 24
}

const enumSACommissionType = new ObjectEx([{
    key: "Fixed",
    value: 1,
    desc: "固定佣金类型"
  },
  {
    key: "Graded",
    value: 2,
    desc: "梯度佣金类型"
  }
]);

const enumSAServiceType = new ObjectEx([{
    key: "Course",
    value: 1,
    desc: "课程类型"
  },
  {
    key: "NonCourse",
    value: 2,
    desc: "非课程类型"
  }, {
    key: "AutoAttrition",
    value: 3,
    desc: "自动消耗类型"
  }
]);

const enumSARangeLimitType = new ObjectEx([{
    key: "Day",
    value: 1,
    desc: "天"
  },
  {
    key: "Month",
    value: 2,
    desc: "个月"
  }, {
    key: "Year",
    value: 3,
    desc: "年"
  }
], {
  getDesc(value) {
    let enumOption = this.valueOf(value);
    return !!enumOption ? enumOption.desc : null;
  }
});

const enumSACountLimitType = new ObjectEx([{
    key: "Total",
    value: 1,
    desc: "总共"
  },
  {
    key: "Monthly",
    value: 2,
    desc: "每月"
  }, {
    key: "Yearly",
    value: 3,
    desc: "每年"
  }
], {
  getOptionsByConditions(rangeLimitType, serviceType) {
    let enumOptions = this.getOptions();

    switch (rangeLimitType) {
      case enumSARangeLimitType.Month:
        enumOptions = enumOptions.filter(item => item.value !== this.Yearly);
        break;
      case enumSARangeLimitType.Year:
        enumOptions = enumOptions;
        break;
      default:
        enumOptions = enumOptions.filter(item => item.value === this.Total);
        break;
    }

    if (serviceType === enumSAServiceType.Course) {
      enumOptions = enumOptions.filter(item => item.value !== this.Monthly);
    }

    return enumOptions;
  }
});

const enumSATimeLimitType = new ObjectEx([{
    key: "Total",
    value: 1,
    desc: "总共"
  },
  {
    key: "Monthly",
    value: 2,
    desc: "每月"
  }, {
    key: "Yearly",
    value: 3,
    desc: "每年"
  }
], {
  getOptionsByConditions(rangeLimitType, serviceType) {
    let enumOptions = this.getOptions();

    switch (rangeLimitType) {
      case enumSARangeLimitType.Month:
        enumOptions = enumOptions.filter(item => item.value !== this.Yearly);
        break;
      case enumSARangeLimitType.Year:
        enumOptions = enumOptions;
        break;
      default:
        enumOptions = enumOptions.filter(item => item.value === this.Total);
        break;
    }

    if (serviceType === enumSAServiceType.Course) {
      enumOptions = enumOptions.filter(item => item.value !== this.Monthly);
    }

    return enumOptions;
  }
});

const enumSAQuantityType = new ObjectEx([{
    key: "Count",
    value: 0,
    desc: "次"
  },
  {
    key: "Hour",
    value: 1,
    desc: "小时"
  }
], {
  getDesc(value) {
    let enumOption = this.valueOf(value);
    return !!enumOption ? enumOption.desc : null;
  }
});

const enumStudyAbroadStatus = new ObjectEx([{
    key: "NotStart",
    value: 0,
    desc: "未开始"
  },
  {
    key: "InProgress",
    value: 1,
    desc: "进行中"
  },
  {
    key: "Completed",
    value: 2,
    desc: "已完成"
  },
  {
    key: "Refund",
    value: 3,
    desc: "已退款"
  },
  {
    key: "Closed",
    value: 4,
    desc: "已关闭"
  },
], {
  getDesc(value) {
    let enumOption = this.valueOf(value);
    return !!enumOption ? enumOption.desc : null;
  }
});

const currencyType = new ObjectEx([{
    key: "CNY",
    value: 1,
    desc: "人民币CNY",
    locale: "zh-CN"
  },
  {
    key: "CAD",
    value: 2,
    desc: "加币CAD",
    locale: "en-CA"
  }
], {
  getFormatter(currency) {
    let enumOption = this.valueOf(currency);
    if (!enumOption)
      return null;

    return new Intl.NumberFormat(enumOption.locale, {
      style: "currency",
      currency: enumOption.key
    });
  },
  format: Object.toCurrency
});

const enumPayeeType = new ObjectEx([{
    key: "Speedup",
    value: 0,
    desc: "速成收款"
  },
  {
    key: "Channel",
    value: 1,
    desc: "渠道收款"
  }
], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", null);
  }
});

const enumRecordType = new ObjectEx([{
    key: "Normal",
    value: 0,
    desc: "正常"
  },
  {
    key: "ForceClose",
    value: 1,
    desc: "强制结束"
  }
]);

const enumTaskAssignmentStatus = new ObjectEx([{
    key: "Incomplete",
    value: 0,
    desc: "未完成分配"
  },
  {
    key: "Completed",
    value: 1,
    desc: "已完成分配"
  }
]);

const inputType = {
  string: 0,
  int: 1,
  decimal: 2,
};

const enumCourseBasicCategory = new ObjectEx([{
    key: "Weekly",
    value: 1,
    desc: "周课"
  },
  {
    key: "PreExam",
    value: 2,
    desc: "考前"
  },
  {
    key: "Combination",
    value: 3,
    desc: "组合"
  },
], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", null);
  },
  getJoinText(valueList) {
    return valueList.map((value) => this.getDesc(value)).join();
  }
}, {
  selectListItems: {
    get() {
      let options = this.getOptions().filter(item => item.value !== 0);

      return options.map(item => ({
        value: item.value,
        label: item.desc
      }));
    }
  }
});

const enumCourseClassGrade = new ObjectEx([{
    key: "FirstGrade",
    value: 1,
    desc: "大一课"
  },
  {
    key: "NotFirstGrade",
    value: 2,
    desc: "非大一课"
  },
], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", null);
  }
});

const enumNormalCourseCategory = new ObjectEx([{
    key: "NormalClass",
    value: 1,
    desc: "长期班"
  },
  {
    key: "Vip",
    value: 2,
    desc: "vip"
  },
  {
    key: "MidtermReview",
    value: 3,
    desc: "期中复习"
  },
  {
    key: "FinalReview",
    value: 4,
    desc: "期末复习"
  },
  {
    key: "FinalPublic",
    value: 5,
    desc: "期末复习公开课"
  },
  {
    key: "OnlineCourse",
    value: 11,
    desc: "线上课程"
  },
  {
    key: "OMO",
    value: 13,
    desc: "OMO模式"
  },
  {
    key: "OfflineCourse",
    value: 14,
    desc: "仅线下课机制"
  },
], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", null);
  }
});

const enumStudyAbroadPriceCategory = new ObjectEx([{
    key: "BiTouBang",
    value: 1,
    desc: "笔头帮"
  },
  {
    key: "University",
    value: 2,
    desc: "大学补习"
  },
  {
    key: "VocationalTraining",
    value: 3,
    desc: "职业培训"
  },
  {
    key: "AcademicSupervision",
    value: 4,
    desc: "学术督导"
  }
], {
  getDesc(value) {
    if (value === 0)
      return "总价";

    return this.getAttrValue(value, "desc", null);
  }
});

const enumBusinessType = new ObjectEx([{
    key: "ToB",
    value: 1,
    desc: "ToB"
  },
  {
    key: "ToC",
    value: 2,
    desc: "ToC"
  }
], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
});

const enumCountryCode = new ObjectEx([{
    key: "China",
    value: 86,
    desc: "中国",
    currency: currencyType.CNY
  },
  {
    key: "Canada",
    value: 1,
    desc: "加拿大",
    currency: currencyType.CAD
  }
], {
  getCurrency(value) {
    return this.getAttrValue(value, "currency");
  },
  // findOptionByCurrency(currency) {
  //   let enumOptions = this.getOptions(item => item.currency === currency);
  //   return enumOptions.length > 0 ? enumOptions[0] : null;
  // }
});

const enumOrgNodeType = new ObjectEx([{
  key: "Department",
  value: 1,
  desc: "部门"
}, {
  key: "Personnel",
  value: 2,
  desc: "人员"
}]);

const enumCourseActivationType = new ObjectEx([{
  key: "None",
  value: 0,
}, {
  key: "EmailVideo",
  value: 1,
}]);

const enumYesNoOptionType = new ObjectEx([{
  key: "None",
  value: 0,
  desc: "空"
}, {
  key: "Yes",
  value: 1,
  desc: "是"
}, {
  key: "No",
  value: 2,
  desc: "否"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
});

const timestampStatusType = new ObjectEx([{
  key: "None",
  value: 0,
  desc: "空"
}, {
  key: "Yes",
  value: 1,
  desc: "一致"
}, {
  key: "No",
  value: 2,
  desc: "不一致"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
});

const cameraStatusType = new ObjectEx([{
  key: "None",
  value: 0,
  desc: "空"
}, {
  key: "Yes",
  value: 1,
  desc: "已打开"
}, {
  key: "No",
  value: 2,
  desc: "未打开"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
});

const speedupElementStatusType = new ObjectEx([{
  key: "None",
  value: 0,
  desc: "空"
}, {
  key: "Yes",
  value: 1,
  desc: "有"
}, {
  key: "No",
  value: 2,
  desc: "无"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
});

const enumPayApiType = new ObjectEx([{
  key: "Checkpay",
  value: 0,
  desc: "Checkpay"
}, {
  key: "AlphaPay",
  value: 1,
  desc: "AlphaPay"
}]);

const enumQuestionnaireQuestionType = new ObjectEx([{
  key: "Unknown",
  value: 0,
  desc: "未知"
}, {
  key: "Choice",
  value: 1,
  desc: "选择"
}, {
  key: "ShortAnswer",
  value: 2,
  desc: "简答"
}, {
  key: "Rate",
  value: 3,
  desc: "评分"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
}, {
  selectListItems: {
    get() {
      let options = this.getOptions().filter(item => item.value !== 0);

      return options.map(item => ({
        value: item.value,
        label: item.desc
      }));
    }
  }
});

const enumQuestionnaireValueType = new ObjectEx([{
  key: "String",
  value: 0,
  desc: "String"
}, {
  key: "Int32",
  value: 1,
  desc: "Int32"
}], {
  getDesc(value) {
    return this.getAttrValue(value, "desc", String.empty);
  }
}, {
  selectListItems: {
    get() {
      let options = this.getOptions();

      return options.map(item => ({
        value: item.value,
        label: item.desc
      }));
    }
  }
});

const enumVideoPlatform = new ObjectEx([{
  key: "SproutVideo",
  value: 0
}, {
  key: "AliyunVod",
  value: 1
}]);

const enumVideoType = new ObjectEx([{
  key: "CourseActivation",
  value: 0
}, {
  key: "Email",
  value: 1
}]);

export default Object.deepFreeze({
  MomentDateFormatISO,
  MomentDateFormatUSA,
  MomentDateFormatCHN,
  debug,
  enumGlobalSettingType,
  roleType, //角色
  loginType, //登陆入口
  bonusPointMechanismType, //积分机制类型
  globalPriceType, //价格类型,
  formulaType, //公式类型
  accountType, //账目类型
  contractType, //合同类型
  otherCollectFeeType, //其他收费类型
  courseType, //课程类型,
  enumYearCourseType,
  universityGroup,
  campuseType,
  enumPaymentType,
  bypassVideoAppointment,
  isOnlineCourse,
  wechatEnable,
  courseScheduleSetting,
  enumSACommissionType,
  enumSAServiceType,
  enumSARangeLimitType,
  enumSACountLimitType,
  enumSATimeLimitType,
  enumSAQuantityType,
  enumStudyAbroadStatus,
  currencyType,
  enumPayeeType,
  enumRecordType,
  enumTaskAssignmentStatus,
  inputType,
  haoJiangTaiDisabled,
  enumCourseBasicCategory,
  enumCourseClassGrade,
  enumNormalCourseCategory,
  enumStudyAbroadPriceCategory,
  enumBusinessType,
  enumCountryCode,
  enumOrgNodeType,
  enumCourseActivationType,
  enumYesNoOptionType,
  timestampStatusType,
  cameraStatusType,
  speedupElementStatusType,
  enumPayApiType,
  enumQuestionnaireQuestionType,
  enumQuestionnaireValueType,
  enumVideoPlatform,
  enumVideoType
});



// WEBPACK FOOTER //
// ./src/core/global.js